// Modules
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { connect } from "react-redux";
import ReactSelect from "react-select";

import TriageDashboard from "routes/dashboards/triage";
import UserDashboard from "routes/dashboards/user";

// Actions
import { useTriageItems } from "modules/triage/store/actions";

// Modules
import _ from "lodash";


const Dashboard = (props) => {
  const { teams, users, user: currentUser } = props;
  const { team, setTeam } = useTriageItems({ user: currentUser });
  
  const nullTeamSelect = { label: "All Teams", value: null };

  const filteredUsers = useMemo(() => {
    console.log('team or users have changed');
    return users
      ? users.filter((user) => {
        if (
          team &&
          user.team &&
          user.team.id !== team.id
        ) {
          return false;
        }
        return true;
      })
      : [];
  }, [team, users]);

  return (
    <div>
      <div>
        <ReactSelect
          options={_.map(teams, (t) => ({
            value: t.id,
            label: t.name
          })).concat([nullTeamSelect])}
          defaultValue={nullTeamSelect}
          value={team ? { value: team.id, label: team.name } : { value: null, label: "All Teams" }}
          onChange={(val) => {
            if (val) {
              setTeam(
                teams.filter((t) => t.id === val.value).length
                  ? teams.filter((t) => t.id === val.value)[0]
                  : null
              );
            } else {
              setTeam(null);
            }
          }}
          style={{ borderRadius: "0", border: "0" }}
        />
      </div>
      <div className="d-flex flex-equal-children relative">
        <div style={{ width: "50%" }}>
          <UserDashboard filteredUsers={filteredUsers} />
        </div>
        <div style={{ width: "50%" }}>
          <TriageDashboard />
        </div>
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  triageItems: PropTypes.array,
  teams: PropTypes.array,
  query: PropTypes.object
};

// Exports
export default connect((state) => ({
  triageItems: state.triage.items,
  users: state.pageData.selectUsers,
  teams: state.pageData.teams,
  user: state.auth.currentUser
}))(Dashboard);
